module.exports = __webpack_public_path__ + "static/media/Acheive8.b8997981.jpeg";